<template>
  <div>
    <!-- Form element that submits all the data in the form to Firebase using the submitData method -->
    <form @submit.prevent="$emit('form-submit', form, day)">
      <!-- Add form fields here, wrapped in a div with a class of field -->
      <div class="field">
        <p>
          How depressed or blue have felt during the past 24 hours at your worst
          (0 not depressed or blue at all; 10 severely depressed/blue):
        </p>
        <Radios
          name="down-level"
          :entry="existingEntry"
          @store-number="storeDownLevel"
          data="downLevel"
          amount="11"
        />
      </div>

      <div class="field">
        <p>
          How anxious have you felt during the past 24 hours at your worst
          (0 not anxious at all; 10 severely anxious)
        </p>
        <Radios
          name="anxiety-level"
          :entry="existingEntry"
          @store-number="storeAnxietyLevel"
          data="anxietyLevel"
          amount="11"
        />
      </div>

      <div class="field">
        <button class="button button--standard" type="submit">
          <span v-if="day.edit">Update</span>
          <span v-else>Log your affect</span>
        </button>
        <button
          class="button button--danger"
          v-if="day.edit"
          @click.prevent="$emit('cancel-edit', day)"
        >Cancel</button>
      </div>
    </form>
  </div>
</template>

<script>
import Radios from "@/components/Radios.vue";

export default {
  name: "Form",
  props: ["existingEntry", "day"],
  components: { Radios },
  methods: {
    storeDownLevel(level) {
      this.form.downLevel = level;
    },
    storeAnxietyLevel(level) {
      this.form.anxietyLevel = level;
    }
  },
  data() {
    return {
      form: {
        // Add form field data here. This data will be submitted to Firestore and
        // should match the v-model values from your form fields.
        downLevel: this.existingEntry ? this.existingEntry.data.downLevel : 0,
        anxietyLevel: this.existingEntry
          ? this.existingEntry.data.anxietyLevel
          : 0
      }
    };
  }
};
</script>

<style>
button {
  margin-right: 1rem;
}
</style>
